import { createSelector } from 'reselect';

import { selectCartItems } from './selectCartItems';

export const selectCartTotalPrice = createSelector(
    [selectCartItems],
    (items) => items
        .filter(item => item.quantity > 0)
        .reduce((acc, item) => acc + item.price * item.quantity, 0),
);
